import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";
import React, { useState } from "react";
import {
  AccordionContent,
  AccordionHeader,
  AccordionIcon,
  AccordionItemWrapper,
  AccordionWrapper,
} from "./styles";
import { AccordionProps } from "./types";

/**
 * Componente Accordion
 *
 * Exibe uma lista de itens expansíveis com título e conteúdo.
 *
 * @param {AccordionItem[]} items - Lista de itens do acordeão.
 */
export const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const toggleItem = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <AccordionWrapper>
      {items.map((item, index) => (
        <AccordionItemWrapper isOpen={activeIndex === index} key={index}>
          <AccordionHeader
            isOpen={activeIndex === index}
            onClick={() => toggleItem(index)}
          >
            <h3>{item.title}</h3>

            <AccordionIcon>
              {activeIndex === index ? (
                <Icon library="md" name="MdKeyboardArrowUp" color="white" />
              ) : (
                <Icon library="md" name="MdKeyboardArrowDown" color="white" />
              )}
            </AccordionIcon>
          </AccordionHeader>
          <AccordionContent isOpen={activeIndex === index}>
            <Typography variant="body" align="left" color="black">
              {item.content}
            </Typography>
          </AccordionContent>
        </AccordionItemWrapper>
      ))}
    </AccordionWrapper>
  );
};
